﻿import { ICenterBase } from '../center-base';
import { IMicrositeEventLog, IMicrositeRecipientCoachLogEntry, IMicrositeRecipientCommunication } from './index';
import { IMicrositeRecipientLog } from './index';
import { IPhoneNumber } from '../phone-number';

export interface IMicrositeRecipientForList {
    id: number,
    shortCodeUses: number,
    shortCode: string,
    editKey: string,
    centerId: number,
    campaignId: number,
    transplantType: number,
    aboTypeId: number,
    aboType: string,
    coordinatorContactId: number,
    coordinatorContact: { id: number, fullName: string, email: string, phoneNumbers: IPhoneNumber[] },
    coordinatorContactName: string,
    secondaryCoordinatorContactId: number,
    secondaryCoordinatorContact: { id: number, fullName: string, email: string, phoneNumbers: IPhoneNumber[] },
    secondaryCoordinatorContactName: string,

    coachContactId: number,
    coachContact: { id: number, fullName: string, email: string, phoneNumbers: IPhoneNumber[] },
    coachContactName: string,
    hideFromCoach: boolean,
    isCoachingDesired: boolean,
    isCoachAllowedToEdit: boolean,
    isCoachOptIn: boolean,
    coachRequestedDateTime: string,
    coachAssignedDateTime: string,
    mostRecentCoachContactDateTime: string,
    coachStatus: number,
    coachStatusDescription: string,
    nextFollowupDate: string,

    email: string,
    secondaryEmail: string,
    firstName: string,
    lastName: string,
    birthdate: string,
    age: number,
    gender: number,
    languagePreferenceId: number,
    languagePreference: string,
    addressLine1: string,
    addressLine2?: string,
    city: string,
    stateId?: number,
    state: string,
    postalCode: string,
    phonePrimary: string,
    phoneSecondary: string,
    currentStatusId: number,
    currentStatusDescription: string,

    customSiteStatusId: number,
    customSiteStatusDescription: string,
    customSiteApprovalWaitDays?: number,

    cheekSwabConsentInitials: string,
    cheekSwabConsentDate: string,

    micrositeBannerStatusId: number,
    micrositeBannerStatusDesc: string,

    isDeleted: boolean,
    isTestSite: boolean,
    inviteSentDateTime: string,
    centerDecisionDateTime: string,
    nkrDecisionDateTime: string,
    patientRegistrationDateTime: string,
    submissionDateTime: string,
    submissionLastIssue: string,
    agreedToHipaa: boolean,
    hasMicrositeSurvey: boolean,

    micrositeTypeId: number,
    micrositeType: string,

    hasPendingChanges: boolean,

    fullName: string,
    center: ICenterBase,
    logs: IMicrositeRecipientLog[],
    coachLogEntries: IMicrositeRecipientCoachLogEntry[],
    businessCardsRequestDate: string,
    cardBatchDateTime: string,
    cardBatchFileName: string,

    isPatientUpdateEnabled: boolean,

    isAddressVerified: boolean,

    deactivationDetails: IDeactivationDetails,
    micrositeEventLogs: IMicrositeEventLog[],
    transplantDate: string,
    dashRegistrationId: number,
    nkrRecipientId: number,
    donorOriginId: number,
    donorOriginOther: string,
    transplantHasMedicare: boolean,
    comms: IMicrositeRecipientCommunication[],
    commStatus: number
    voucherOrTransplantEvents: IMicrositeEventLog[],
    mostRecentCoachNotificationEvent: IMicrositeEventLog,
    starterSiteActiveDate: string
}

export interface IDeactivationDetails {
    transplantDate: string,
    donorOrigin: string,
    transplantedFromDashRegistration: boolean,
    reason: string
}
